import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Footer } from "@/components/shared";
import { site } from "@/config/site";

const Shell = ({ title, overline, children }) => (
  <div>
    <Navbar />
    <main className="pt-header">
      <article className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="overline mb-3">{overline}</p>
        <h1 className="text-4xl md:text-5xl font-serif font-light text-primary">{title}</h1>
        <div className="mt-10 space-y-6 text-muted-foreground leading-relaxed">{children}</div>
        <p className="mt-12 text-sm">
          <Link to="/" className="text-primary border-b-2 border-accent pb-0.5">Torna alla home</Link>
        </p>
      </article>
    </main>
    <Footer />
  </div>
);

export function PrivacyPage() {
  return (
    <Shell overline="Informativa" title="Privacy">
      <p>
        Titolare del trattamento è {site.nome}, {site.indirizzo}, email{" "}
        <a className="text-primary underline" href={`mailto:${site.email}`}>{site.email}</a>, tel.{" "}
        <a className="text-primary underline" href={`tel:${site.telefonoRaw}`}>{site.telefono}</a>
        {site.piva ? ` · ${site.piva}` : ""}.
      </p>
      <h2 className="text-2xl font-serif text-primary">Dati raccolti</h2>
      <p>
        Trattiamo i dati che ci comunica tramite il modulo di contatto e il configuratore di preventivo
        (nome, recapiti, note e scelte di servizio) per rispondere alle richieste, elaborare un preventivo
        non vincolante e, se necessario, erogare i servizi funebri.
      </p>
      <h2 className="text-2xl font-serif text-primary">Base giuridica e conservazione</h2>
      <p>
        Il trattamento si fonda sull’esecuzione di misure precontrattuali su sua richiesta e, per i
        messaggi dal sito, sul consenso. I dati delle richieste vengono conservati per il tempo
        necessario a gestire la pratica e gli obblighi di legge, e comunque non oltre 24 mesi in assenza
        di rapporto contrattuale.
      </p>
      <h2 className="text-2xl font-serif text-primary">Diritti</h2>
      <p>
        Può chiedere accesso, rettifica, cancellazione, limitazione o opposizione scrivendo a {site.email}.
        Ha inoltre diritto di reclamo al Garante per la protezione dei dati personali.
      </p>
      <p className="text-sm">Ultimo aggiornamento: agosto 2026.</p>
    </Shell>
  );
}

export function CookiePage() {
  return (
    <Shell overline="Informativa" title="Cookie">
      <p>
        Questo sito utilizza cookie tecnici necessari al funzionamento (ad esempio per ricordare il
        consenso) e, solo dopo il consenso dal banner, strumenti di misurazione dell’utilizzo delle pagine.
      </p>
      <h2 className="text-2xl font-serif text-primary">Come gestire il consenso</h2>
      <p>
        Può accettare dal banner in fondo alle pagine. Per revocare, cancelli i cookie del browser
        relativi a questo sito: al successivo accesso il banner verrà riproposto.
      </p>
      <p>
        Maggiori dettagli sul trattamento dei dati sono nella{" "}
        <Link to="/privacy" className="text-primary underline">informativa privacy</Link>.
      </p>
    </Shell>
  );
}
